import React from 'react';

import { Modal, type ModalProps } from '@depop/web-ui-kit/Modal';

import { BasedOnRecentViewsProductCard } from './BasedOnRecentViewsProductCard';
import styles from './styles.module.css';

import { type BasedOnRecentViewsRecommendationsProduct } from '@/modules/product/aliases';

type Props = Pick<ModalProps, 'isOpen' | 'setOpen'> & {
  title: string;
  products: BasedOnRecentViewsRecommendationsProduct[];
  onProductClick?: (product: BasedOnRecentViewsRecommendationsProduct) => void;
};

export function BasedOnRecentViewsModal({
  isOpen,
  setOpen,
  title,
  products,
  onProductClick = () => null,
}: Props) {
  return (
    <Modal
      wide
      isOpen={isOpen}
      setOpen={setOpen}
      title={title}
      content={() => (
        <div className={styles.modalContent}>
          <ul className={styles.productGrid}>
            {products.map((product) => (
              <li key={product.id}>
                <BasedOnRecentViewsProductCard
                  product={product}
                  onClick={onProductClick}
                />
              </li>
            ))}
          </ul>
        </div>
      )}
    />
  );
}
